import { render, staticRenderFns } from "./BannerGaleriaTemplate.vue?vue&type=template&id=2d7ffea0&scoped=true&lang=pug"
import script from "./BannerGaleriaTemplate.vue?vue&type=script&lang=js"
export * from "./BannerGaleriaTemplate.vue?vue&type=script&lang=js"
import style0 from "./BannerGaleriaTemplate.styl?vue&type=style&index=0&id=2d7ffea0&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ffea0",
  null
  
)

export default component.exports